import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Menu, User, Bell } from 'lucide-react';

const Header = () => {
  return (
    <motion.header 
      className="bg-white/95 backdrop-blur-lg border-b border-green-100 sticky top-0 z-50 shadow-sm"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <motion.div 
            className="flex items-center gap-3"
            whileHover={{ scale: 1.05 }}
          >
            <div className="p-2 bg-gradient-to-br from-green-500 to-blue-500 rounded-xl">
              <MapPin className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
                TuriCosta
              </h1>
              <p className="text-xs text-gray-500 font-medium">Pura Vida Transport</p>
            </div>
          </motion.div>

          <div className="flex items-center gap-4">
            <motion.button
              className="p-2 rounded-xl bg-gray-100 hover:bg-gray-200 transition-colors"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              <Bell className="w-5 h-5 text-gray-600" />
            </motion.button>
            
            <motion.button
              className="p-2 rounded-xl bg-gray-100 hover:bg-gray-200 transition-colors"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              <User className="w-5 h-5 text-gray-600" />
            </motion.button>

            <motion.button
              className="p-2 rounded-xl bg-gray-100 hover:bg-gray-200 transition-colors md:hidden"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              <Menu className="w-5 h-5 text-gray-600" />
            </motion.button>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;